goog.provide('el8.appchart.dialog.ordermed.confirmPharmacyNote');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appchart.dialog.ordermed.confirmPharmacyNote');


el8.appchart.dialog.ordermed.confirmPharmacyNote = (function() {

    var model = null;
    var saveCallbackFn = null;
    var hideCallbackFn = null;
    var reason = '';

    var MAX_LENGTH = 180;

    var that = new el8.uiwidget.FormDialog({
        title: "Confirm prescription note",
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.ordermed.confirmPharmacyNote.content
    });

    that.OVERRIDE_REASON_PREFIX = 'Override contra-indication: ';

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'pharmacyNote',
                type: 'input',
                selector: ':input[name="pharmacyNote"]',
                infoText: 'prescription note...',
                height: 60,
                maxLength: MAX_LENGTH
            }
        ]
    });
    form.addButton('save', 'Prescribe', function(_form) {
        var note = _form.getVal('pharmacyNote');
        model.setPharmacyInstructions(note);
        if (saveCallbackFn) { saveCallbackFn(note); }
        that.hide();
    }, true);
    form.addButton('cancel', 'Cancel', function(_form) {
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {

        super_show.call(that);

        spec = spec || {};
        reason = spec.reason || '';
        model = spec.model || null;
        saveCallbackFn = spec.saveCallbackFn;
        hideCallbackFn = spec.hideCallbackFn;

        var note = el8.util.string.replaceNewlines(model.getPharmacyInstructions());
        reason = that.OVERRIDE_REASON_PREFIX + reason.trim();
        if (!reason.endswith('.')) { reason += '.'; }
        if (note.indexOf(reason) === -1) { note = reason + ' ' + note; }

        if (note.length > MAX_LENGTH) {
            $('.confirm-pharmacy-alert-msg', that.getContainer()).html(
                el8.template.appchart.dialog.ordermed.confirmPharmacyNote.alertMsg({
                    msg: 'We\'re sorry. We can only send '+MAX_LENGTH+' characters to the pharmacy. Please edit your message below.'
                })
            );
            form.setVal('pharmacyNote', note.substr(0, MAX_LENGTH));
        } else {
            $('.confirm-pharmacy-alert-msg', that.getContainer()).html(
                el8.template.appchart.dialog.ordermed.confirmPharmacyNote.msg({
                    msg: 'Please confirm the note that will be sent to the pharmacy along with your script.'
                })
            );
            form.setVal('pharmacyNote', note);
        }
    };

    var super_hide = that.hide;
    that.hide = function(spec) {
        // This causes the hideCallbackFn to also be called
        // when save is hit, but that's ok in this case.  Have to do for now
        // so that the "x" acts as desired
        super_hide.call(that);
        if (hideCallbackFn) { hideCallbackFn(); }
    };

    return that;

})();

